// app/plugins/tableau.client.ts
export default defineNuxtPlugin(async () => {
    if (customElements.get('tableau-viz')) return;

    await new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://tableau.formeo-online.co.uk/javascripts/api/tableau.embedding.3.latest.min.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Tableau Embedding API'));
        document.head.appendChild(script);
    });
});